module.exports = __webpack_public_path__ + "img/teste.79a1a6a7.jpg";